import {
  InlineButton,
  InlineButtonAlignments,
  ControlSizesMD,
} from '@picsart/design-system/components/InlineButton';
import useStyles from './styles';
import type { SettingsLink } from './types';

interface SettingsLinkButtonProps {
  link: SettingsLink;
  onClick: (url: string) => void;
}

const SettingsLinkButton = ({ link, onClick }: SettingsLinkButtonProps) => {
  const classes = useStyles();

  return (
    <InlineButton
      className={classes.actionButton}
      dataTestId={`genai-settings-link-${link.label}`}
      size={ControlSizesMD}
      startIcon={link.icon}
      alignment={InlineButtonAlignments.Start}
      isFullWidth
      isWithoutBorder
      onClick={() => onClick(link.url)}
    >
      {link.label}
    </InlineButton>
  );
};

export default SettingsLinkButton;
